query getValuationInputLimits($input: GetValuationInputLimitsInput!) {
  inputLimits: getValuationInputLimits(input: $input) {
    buildingYear {
      min
      max
    }
    livingArea {
      min
      max
    }
    numberOfRooms {
      min
      max
    }
    balconyArea {
      min
      max
    }
    landArea {
      min
      max
    }
    numberOfUnits {
      min
      max
    }
    floorNumber {
      min
      max
    }
    annualRentIncome {
      min
      max
    }
  }
}
